/**
 * Centralized Theme System
 *
 * This module exports all theme constants for use in both:
 * - Legacy MashieWeb React components
 * - Modern Next.js frontend
 *
 * All values are derived from Bootstrap 3 variables to maintain consistency
 * with the existing legacy system while providing modern MUI theming.
 */

export { palette } from './palette';
export type { Palette } from './palette';

export { typography } from './typography';
export type { Typography } from './typography';

export { spacing } from './spacing';
export type { Spacing } from './spacing';

export { breakpoints } from './breakpoints';
export type { Breakpoints } from './breakpoints';

export { components } from './components';

// Re-export everything as a single object for convenience
import { palette } from './palette';
import { typography } from './typography';
import { spacing } from './spacing';
import { breakpoints } from './breakpoints';
import { components } from './components';

export const themeConstants = {
  palette,
  typography,
  spacing,
  breakpoints,
  components,
} as const;

export default themeConstants;
